export default "__VITE_ASSET__CjHhzJTo__"